<template>
    <section class="payment-complete mt-2">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="text-center">
                        <p class="card-text p-3">{{ $t("Please choose a pick up time in order to continue.") }}</p>
                        <div>
                            <router-link
                                class="btn btn-click-and-collect btn-choose-pickup-time w-100 w-md-auto mb-3 mb-md-0"
                                :to="`/${siteSlug}/select-slot`">
                                {{ $t("Choose pickup time") }}
                            </router-link>

                            <button class="btn btn-click-and-collect w-100 w-md-auto eat-in-button"
                                v-on:click="switchToEatIn" v-if="enabledMenus.eat_in">
                                {{ $t("Switch to eat-in") }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: ['siteSlug'],
    data() {
        return {
            enabledMenus: window.app.enabled_menus
        }
    },
    methods: {
        switchToEatIn() {
            window.location.href = `/${this.siteSlug}/eat-in`;
        }
    }
}
</script>
